import styles from './AmbientBackdrop.module.scss'

export function AmbientBackdrop() {
  return <div className={styles.backdrop} aria-hidden />
}
